import { InputSwitch } from 'primereact/inputswitch'
import styled from 'styled-components'

export const SwitchContainer = styled.label`
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    margin-bottom: 1rem;
`

export const Label = styled.label`
    margin-left: 0.5rem;
`

export const CustomInputSwitch = styled(InputSwitch)`
    .p-inputswitch-slider {
        background-color: #ddd; /* Default slider background color */
        border: 1px solid #ddd; /* Default border color */
    }
    .p-inputswitch:checked .p-inputswitch-slider {
        background-color: #ba9d31 !important; /* Background color when checked */
        border: 1px solid #ba9d31 !important; /* Border color when checked */
    }
    .p-inputswitch-slider:before {
        background-color: #ffffff; /* Circle inside color */
        border: 1px solid #ba9d31; /* Circle border color when checked */
    }
`
